const config = {
    'BASE_URL': 'https://api-prod.wannalisn.com',       
    'READ_SERVER_URL': 'https://read-prod.wannalisn.com/v1/graphql'
}

export default config